'use strict';

var $       = require('jquery'),
    rafDebounce = require('./functions/browser/raf-debounce'),
    window  = require('window');

var jQueryDebounce = (function ($) {
    var timing,
        typeDebouncer,
        runFncAsap;

    /**
     * Debouncer tradizionale con setTimeout
     * @param $
     * @param currentEvt
     * @param oldEvt
     * @param interval
     */
    var deBouncer = function ($, currentEvt, oldEvt, interval, inamespace) {

        var removeEvt = 'remove' + currentEvt.charAt(0).toUpperCase() + currentEvt.slice(1),
            internalNamespace = $.isDefined(inamespace) ? inamespace : '.bouncensp',
            definedEvent = [];

        /*
         * deBouncer by hnldesign.nl
         * based on code by Paul Irish and the original debouncing function from John Hann
         * http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
         **/
        var debounce = function (func, execAsap) {
            var timeout;
            return function debounced() {
                var obj = this, args = arguments;

                function delayed() {
                    if (typeof execAsap === 'undefined' || !execAsap) {
                        func.apply(obj, args);
                    }
                    timeout = null;
                }

                if (timeout) {
                    clearTimeout(timeout);
                } else if (execAsap) {
                    func.apply(obj, args);
                }

                timeout = setTimeout(delayed, interval || 150);
            };
        };

        /**
         * Estendo il prototype di jQuery con i nuovi metodi debouncer
         */
        definedEvent[currentEvt] = $.isDefined( $.fn[currentEvt] );
        definedEvent[removeEvt] = $.isDefined( $.fn[removeEvt] );

        if(!definedEvent[currentEvt]){
            $.fn[currentEvt] = function (fn, singleNamespace) {
                var componentNamespace = $.isDefined(singleNamespace) ? '.' + singleNamespace : '.default';
                return fn ? this.on(oldEvt + internalNamespace + componentNamespace, debounce(fn, runFncAsap)) : this.trigger(currentEvt);
            };
        }

        if(!definedEvent[removeEvt]){
            $.fn[removeEvt] = function ( singleNamespace ) {
                var componentNamespace = $.isDefined(singleNamespace) ? '.' + singleNamespace : '.default';
                this.off(oldEvt + internalNamespace + componentNamespace);
            };
        }
    };

    /**
     * Debouncer con l'uso di requestAnimationFrame se supportato, altrimenti con setTimeout
     * @param $
     * @param currentEvt
     * @param oldEvt
     */
    var rAFDebouncer = function ($, currentEvt, oldEvt, interval, inamespace) {

        var removeEvt = 'remove' + currentEvt.charAt(0).toUpperCase() + currentEvt.slice(1),
            internalNamespace = $.isDefined(inamespace) ? inamespace : '.bouncensp',
            definedEvent = [];

        /**
         * Estendo il prototype di jQuery con i nuovi metodi debouncer
         */
        definedEvent[currentEvt] = $.isDefined( $.fn[currentEvt] );
        definedEvent[removeEvt] = $.isDefined( $.fn[removeEvt] );


        if(!definedEvent[currentEvt]){
            $.fn[currentEvt] = function (fn, singleNamespace) {
                var componentNamespace = $.isDefined(singleNamespace) ? '.' + singleNamespace : '.default';
                return fn ? this.on(oldEvt + internalNamespace + componentNamespace, rafDebounce(fn, runFncAsap)) : this.trigger(currentEvt);
            };
        }

        if(!definedEvent[removeEvt]){
            $.fn[removeEvt] = function ( singleNamespace ) {
                var componentNamespace = $.isDefined(singleNamespace) ? '.' + singleNamespace : '.default';
                this.off(oldEvt + internalNamespace + componentNamespace);
            };
        }
    };

    /**
     * Inizialize e estensione del jQuery prototype con le nuove funzioni debounce create in base al parametro typeDebouncer
     * @param options
     */
    var initialize = function ( opt ) {
        var namespace = opt.namespace ? '.' + opt.namespace : '.bouncensp',
            definedDebouncer = false;

        /* * setting options * */
        timing = opt.timing || 150;
        typeDebouncer = opt.type || 'rAF';
        runFncAsap = opt.fncAsap || false;

        /* funzioni piu' comuni con debounce automatico */
        definedDebouncer = false || $.isDefined( $.fn['resizeDebouncer'] ) || $.isDefined( $.fn['scrollDebouncer'] ) || $.isDefined( $.fn['mousemoveDebouncer'] );

        if(!definedDebouncer){

            if ('rAF' === typeDebouncer) {
                rAFDebouncer($, 'resizeDebouncer', 'resize', timing, namespace);
                rAFDebouncer($, 'scrollDebouncer', 'scroll', timing, namespace);
                rAFDebouncer($, 'mousemoveDebouncer', 'mousemove', timing, namespace);
            } else {
                deBouncer($, 'resizeDebouncer', 'resize', timing, namespace);
                deBouncer($, 'scrollDebouncer', 'scroll', timing, namespace);
                deBouncer($, 'mousemoveDebouncer', 'mousemove', timing, namespace);
            }

        }

    };

    var root = {
        init: initialize
    };

    return root;

})($);

module.exports = jQueryDebounce;
